import * as actionType from "./actionTypes";
import { getRequestAuthed, postRequestAuthed, processError, prepPostData } from "../../utils/apiHandlers";
import { LOADING_STATE, LS_ITEM_ADMIN, NOTIF_TYPE } from "../../utils/stateTypes";
import { deleteItemLocal, editItemProp, editItemPropByID, setItemEditing, updateItemLocal } from "../../utils/actionUtils";
import { adminCollectionSelectors } from "../rootSelectors";
import _notif from "../notification";

export const loadCollections = (categoryID) => (
  (dispatch) => {
    const lsItem = LS_ITEM_ADMIN.COLLECTIONS_LOAD;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));
    getRequestAuthed(`/AdminCollection/GetCollections/${categoryID}`,
      (collections) => {
        const formattedCollection = {
          byID: {},
          allIDs: [],
        };

        for (let collection of collections) {
          formattedCollection.byID[collection.id] = collection;
          formattedCollection.allIDs.push(collection.id);
        }

        dispatch({
          type: actionType.RECEIVE_COLLECTIONS,
          collection: formattedCollection,
        });
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);

export const setCollectionEditing = setItemEditing(actionType.SET_COLLECTION_EDITING);
export const editCollectionProp = editItemProp(actionType.EDIT_COLLECTION_PROP);
export const editCollectionByIdProp = editItemPropByID(actionType.EDIT_COLLECTION_BY_ID_PROP);
const updateCollectionLocal = updateItemLocal(actionType.UPDATE_COLLECTION, "collection");
const deleteCollectionLocal = deleteItemLocal(actionType.DELETE_COLLECTION);

export const addCollection = (categoryID) => (
  (dispatch) => {
    let lsItem = LS_ITEM_ADMIN.COLLECTION_ADD;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));
    postRequestAuthed("/AdminCollection/AddCollection",
      categoryID,
      (collection) => {
        dispatch(updateCollectionLocal(collection, true));
        dispatch(_notif.actions.queueNotification("Collection added", NOTIF_TYPE.SUCCESS));
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);

export const saveCollection = () => (
  (dispatch, getState) => {
    const collection = adminCollectionSelectors.getCollectionEditing(getState());

    let postData = prepPostData(collection, ["previewImage", "previewVideo", "headerImage", "headerVideo"]);

    //Separate the info section files
    let extraFiles = [];
    if (collection.infoSections) {
      let newInfoSections = [];
      for (let item of collection.infoSections) {
        if (!item.image || !item.body) {
          continue;
        }
        const processedItem = prepPostData(item, ["image"]);
        newInfoSections.push(processedItem.item);
        if (processedItem.newFiles.length > 0) {
          processedItem.newFiles[0].propName = item.id.toString();
        }
        extraFiles = [
          ...extraFiles,
          ...processedItem.newFiles,
        ];
      }
      postData.item.infoSections = newInfoSections;
    }

    let lsItem = LS_ITEM_ADMIN.COLLECTION_SAVE;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));
    postRequestAuthed("/AdminCollection/SaveCollection",
      {
        item: postData.item,
        newFiles: postData.newFiles,
        extraFiles,
      },
      (collection) => {
        dispatch(updateCollectionLocal(collection));
        dispatch(setCollectionEditing(collection.id));

        dispatch(_notif.actions.queueNotification("Collection updated", NOTIF_TYPE.SUCCESS));
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);

export const deleteCollection = (id, onSuccess=null) => (
  (dispatch) => {
    let lsItem = `${LS_ITEM_ADMIN.COLLECTION_DELETE}${id}`;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));
    postRequestAuthed("/AdminCollection/DeleteCollection",
      id,
      () => {
        dispatch(deleteCollectionLocal(id));

        dispatch(_notif.actions.queueNotification("Collection deleted. Its products are now unassigned.", NOTIF_TYPE.SUCCESS));
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
        if (onSuccess) {
          onSuccess();
        }
      },
      processError(dispatch, _notif, lsItem),
    );
  }
);

export const reorderCollections = (startIndex, endIndex, categoryID) => (
  (dispatch, getState) => {
    //Get the currently sorted items
    const allIDs = adminCollectionSelectors.getCollections(getState()).map((item) => item.id);
    let newOrder = [...allIDs];
    //Move from the start index to the end index (and get the moved itemID in the process)
    const [itemID] = newOrder.splice(startIndex, 1);
    newOrder.splice(endIndex, 0, itemID);

    //Save the order locally
    dispatch({
      type: actionType.REORDER_COLLECTIONS,
      newOrder,
    });

    const lsItem = `${LS_ITEM_ADMIN.COLLECTION_REORDER}${itemID}`;
    dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADING));
    postRequestAuthed("/AdminCollection/ReorderCollections",
      {
        startIndex,
        endIndex,
        parentID: categoryID,
      },
      () => {
        dispatch(_notif.actions.queueNotification("Re-ordered successfully", NOTIF_TYPE.SUCCESS));
        dispatch(_notif.actions.setLoadState(lsItem, LOADING_STATE.LOADED));
      },
      processError(dispatch, _notif, lsItem, () => {
        //Undo the local change if the server request fails
        dispatch({
          type: actionType.REORDER_COLLECTIONS,
          newOrder: allIDs,
        });
      }),
    );
  }
);
